import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdKypApi, KypAddCustomerRequest, KypCustomer, KypEwsEvent } from '../tokens/ed-kyp.token';

/**
 * REST implementation of the E-D KYP Compliance API (PRD §3.12 / §2.7, EM-847). Bound to ED_KYP.
 *
 * The Lendox Pure Analytics KYP product is a SEPARATE subscription platform reached over REST. Its
 * backend surface `/api/v1/kyp/*` is NOT built yet (PRD [OPEN]).
 *
 * Per Rule 10 this is NOT a `Mock*` service: every method targets the REAL path via `HttpClient`, so
 * the day the KYP product lands only the backend needs wiring — this service is already correct. Until
 * then the calls resolve to the platform's structured RFC-7807 error (404/501), which the component
 * surfaces through `extractBackendErrorMessage` (Rule 09) as an "analytics not yet available" banner —
 * never fabricated customers or EWS data.
 *
 * // TODO(backend): GET /api/v1/kyp/customers, POST /api/v1/kyp/customers,
 * //                POST /api/v1/kyp/customers/{id}/analyze, GET /api/v1/kyp/customers/{id}/ews,
 * //                (and /limits) — Rule 10 blocker until the Lendox Pure Analytics KYP product lands.
 */
@Injectable({ providedIn: 'root' })
export class EdKypRestService implements EdKypApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/kyp`;

  listCustomers(): Observable<KypCustomer[]> {
    // TODO(backend): GET /api/v1/kyp/customers — Rule 10 blocker until the LPA KYP product lands.
    return this.http.get<KypCustomer[]>(`${this.base}/customers`);
  }

  addCustomer(request: KypAddCustomerRequest): Observable<KypCustomer> {
    // TODO(backend): POST /api/v1/kyp/customers — Rule 10 blocker until the LPA KYP product lands.
    return this.http.post<KypCustomer>(`${this.base}/customers`, request);
  }

  analyze(customerId: string): Observable<KypCustomer> {
    // TODO(backend): POST /api/v1/kyp/customers/{id}/analyze — Rule 10 blocker until the LPA KYP product lands.
    return this.http.post<KypCustomer>(`${this.base}/customers/${customerId}/analyze`, {});
  }

  getEws(customerId: string): Observable<KypEwsEvent[]> {
    // TODO(backend): GET /api/v1/kyp/customers/{id}/ews — Rule 10 blocker until the LPA KYP product lands.
    return this.http.get<KypEwsEvent[]>(`${this.base}/customers/${customerId}/ews`);
  }
}
